<div *ngIf="!baseReady" class="w-full h-full fadein">
  <p-skeleton height="100%"></p-skeleton>
</div>
<div
  [style]=" baseReady ? (elementRef?.nativeElement?.parentNode | elementSize) : 'z-index: -1'"
  class="relative"
>
  <div
    *ngFor="let item of layers; let i = index"
    [id]="'container-layer-' + i"
    [class.bg-white-alpha-80]="i > 0"
    @fade
    class="absolute fadein w-full h-full top-0 left-0"
    [style]="baseReady ? 'z-index: auto;': 'z-index: -1;'"
  ></div>
</div>

<div
  [hidden]="!tooltipVisible"
  [style.left.px]="tooltipX - offsetX"
  [style.top.px]="tooltipY - offsetY - 7"
  class="tooltip shadow-3"
>
  <p *ngIf="tooltipArgs?.title" class="font-bold mb-2">{{tooltipArgs.title}}</p>
  <div *ngFor="let row of tooltipArgs?.rows" class="flex justify-content-between gap-3">
    <p [class.font-bold]="!tooltipArgs?.title" class="mb-0">{{row.label}}:</p>
    <div class="flex">
      <p class="mb-0">
        {{getMeasurementOfSensorIdentifier(row.value).lastValueReported}}
      </p>
      <p *ngIf="tooltipArgs.showDates" class="mb-0">
        &nbsp;~ {{getMeasurementOfSensorIdentifier(row.value).dateLastValueReported | customDate}}
      </p>
    </div>
  </div>
</div>
